'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = require('babel-runtime/helpers/get');

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _user = require('redux/actions/user');

var _BaseForm2 = require('components/BaseForm');

var _BaseForm3 = _interopRequireDefault(_BaseForm2);

var _modal = require('redux/actions/modal');

var _reactSAlert = require('react-s-alert');

var _reactSAlert2 = _interopRequireDefault(_reactSAlert);

var _helpers = require('helpers');

var _Validators = require('./Validators');

var Validators = _interopRequireWildcard(_Validators);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PasswordChange = (_dec = (0, _reactRedux.connect)(function (state) {
    return {
        change: state.user.change,
        error: state.user.error,
        errorCode: state.user.errorCode,
        preload: state.user.preload,
        server_not_found: state.error.server_not_found,
        user: state.auth.user,
        lang: state.lang
    };
}, {
    changePassword: _user.changePassword,
    hide: _modal.hide,
    resetError: _user.resetError
}), _dec(_class = (_temp = _class2 = function (_BaseForm) {
    (0, _inherits3.default)(PasswordChange, _BaseForm);

    function PasswordChange(props, context) {
        (0, _classCallCheck3.default)(this, PasswordChange);

        var _this = (0, _possibleConstructorReturn3.default)(this, (PasswordChange.__proto__ || (0, _getPrototypeOf2.default)(PasswordChange)).call(this, props, context));

        _this.handlerChangeNewPass = function (event) {
            _this.setState({
                newPass: event.target.value
            });
        };

        _this.handlerChangeNewRePass = function (event) {
            _this.setState({
                newRePass: event.target.value
            });
        };

        _this.handlerChangeOldPass = function (event) {
            _this.setState({
                oldPass: event.target.value
            });
        };

        _this.state = {
            error: '',
            errorCode: null,
            newPass: '',
            newRePass: '',
            oldPass: ''
        };
        return _this;
    }

    (0, _createClass3.default)(PasswordChange, [{
        key: 'onSubmit',
        value: function onSubmit(event) {
            (0, _get3.default)(PasswordChange.prototype.__proto__ || (0, _getPrototypeOf2.default)(PasswordChange.prototype), 'onSubmit', this).call(this, event);

            if (this.isValid()) {
                var user = this.props.user;


                this.props.changePassword(user.phone || user.email, this.state.newPass, this.state.newRePass, this.state.oldPass);

                this.props.resetError();
                this.setState({
                    error: '',
                    errorCode: null,
                    newPass: '',
                    newRePass: '',
                    oldPass: ''
                });
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.props.resetError();
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var _props = this.props,
                change = _props.change,
                lang = _props.lang;


            if (change !== nextProps.change && nextProps.change) {
                this.props.hide();
                setTimeout(function () {
                    _reactSAlert2.default.success(lang['store.password_recovery.success'], { position: 'top-right', effect: 'slide', timeout: 5000 });
                }, 1000);
            }
        }
    }, {
        key: 'isValid',
        value: function isValid() {
            this.props.resetError();

            var lang = this.props.lang;

            var lengthError = lang['store.password_recovery.pass_length_error'];
            var mismatchError = lang['store.password_change.password_mismatch'];

            if (!Validators.minLength(this.state.newPass, 6)) {
                this.setState({ error: lengthError, errorCode: 400 });
                return false;
            }

            if (this.state.newPass !== this.state.newRePass) {
                this.setState({ error: mismatchError, errorCode: 400 });
                return false;
            }

            return true;
        }
    }, {
        key: 'isMinValid',


        /**
         * Валидация по всем методам проверки
         * @returns {boolean}
         */
        value: function isMinValid() {
            return this.state.newPass.length > 0 && this.state.newRePass.length > 0 && this.state.oldPass.length > 0;
        }
    }, {
        key: 'render',
        value: function render() {
            var View = _helpers.ThemeHelper.getViewForComponent('PasswordChange', null, { folderName: 'PasswordChange' });

            return _react2.default.createElement(View, {
                disabledSubmit: !this.isMinValid(),
                error: this.props.error || this.state.error,
                errorCode: this.state.errorCode || this.props.errorCode,
                newPass: this.state.newPass,
                newRePass: this.state.newRePass,
                oldPass: this.state.oldPass,
                onChangeNewPass: this.handlerChangeNewPass,
                onChangeNewRePass: this.handlerChangeNewRePass,
                onChangeOldPass: this.handlerChangeOldPass,
                onSubmit: this.onSubmit,
                preload: this.props.preload,
                server_not_found: this.props.server_not_found,
                lang: this.props.lang
            });
        }
    }]);
    return PasswordChange;
}(_BaseForm3.default), _class2.propTypes = {
    change: _react.PropTypes.any,
    changePassword: _react.PropTypes.func.isRequired,
    error: _react.PropTypes.any,
    errorCode: _react.PropTypes.any,
    hide: _react.PropTypes.func.isRequired,
    preload: _react.PropTypes.any,
    resetError: _react.PropTypes.func.isRequired,
    server_not_found: _react.PropTypes.any,
    user: _react.PropTypes.object.isRequired,
    lang: _react.PropTypes.object
}, _temp)) || _class);
exports.default = PasswordChange;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/PasswordChange/PasswordChange.jsx
// module id = 1730
// module chunks = 0